/* istanbul ignore file */
import type { ReactNode } from 'react';
import React from 'react';
import { IconClose } from '@noths/polaris-client-ribbons-design-system';
import { iconButton, visuallyHidden } from '@noths/polaris-client-styles';

import * as styles from './Modal.styles';

interface ModalProps {
  onClose?: VoidFunction;
  children: ReactNode;
}

export const Modal = ({ onClose, children }: ModalProps) => {
  return (
    <div css={styles.container}>
      <div css={styles.modalContent}>
        {children}
        <button css={[iconButton, styles.closeBtn]} onClick={onClose}>
          <div css={styles.iconContainer}>
            <IconClose height={32} width={32} color="var(--dgg-neutral-white)" />
          </div>
          <span css={visuallyHidden}>Close</span>
        </button>
      </div>
    </div>
  );
};
